
import './toolset-selection.styles.scss';
import TabContainer from '../Common/tab-container/tab-container.component';
import YourStack from './toolset-selection/your-stack';
import BrowseByTechnology from './toolset-selection/browse-by-technology';
import { ROUTE_PATHS } from '../../constants/app.constants';

export const TOOLSET_TABS = {
  YOUR_STACK: 'your-stack',
  BROWSE_BY_TECHNOLOGY: 'browse-by-technology',
}

const tabs = [
  { label: 'Tools', key: TOOLSET_TABS.YOUR_STACK, component: YourStack, pathname: '' },
  { label: 'Map your stack', key: TOOLSET_TABS.BROWSE_BY_TECHNOLOGY, component: BrowseByTechnology, pathname: '' },
]

const ToolsetSelection = ({ clientId, toolData, searchMspTools, setOpenTool, refreshIntegrsInfo, refreshTechToolData }) => {
  return (
    <div className="toolset-selection-container">
      <TabContainer
        tabs={tabs}
        containerClassName=""
        tabContentProps={{
          clientId,
          toolData,
          searchMspTools,
          setOpenTool,
          refreshIntegrsInfo,
          refreshTechToolData,
          showAddButton: false,
          isView: true
        }}
      />
    </div>
  )
}

export default ToolsetSelection;

